<template>
    <div class="columns">
        <div class="column">
            <multiselect
                :loading="list.loading"
                :options="list.data.results || []"
                v-validate="'required'"
                :internal-search="false"
                @search-change="search"
                placeholder="Search team to add"
                v-model="form.team"
                track-by="id"
                label="name"
                name="team"/>
            <p class="help is-danger">{{ errors.first('team') }}</p>
        </div>

        <div class="column">
            <multiselect
                v-model="form.role"
                placeholder="Select role"
                v-validate="'required'"
                :options="roles"
                track-by="value"
                select-label=""
                label="label"
                name="role"/>

            <p class="help is-danger">{{ errors.first('role') }}</p>
        </div>

        <div class="column is-narrow">
            <base-button
                :loading="creation.loading"
                @click="create"
                class="is-primary add-button"
                icon="fas fa-plus"
                text="Add"/>
        </div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import { mapState } from 'vuex';
import { roles } from '../../utils/constants';

export default {
    components: { Multiselect },
    props: ['space_id'],
    data() {
        return {
            form: { team: null, role: null },
            roles,
        };
    },
    computed: {
        ...mapState('teams', ['list']),
        ...mapState('space_teams', { creation: 'create' }),
    },
    methods: {
        search(query) {
            this.$store.dispatch('teams/list', { search: query });
        },
        create() {
            this.$validator.validate().then((result) => {
                if (!result) return;

                this.$store.dispatch('space_teams/create', {
                    space_id: this.space_id,
                    team_id: this.form.team.id,
                    role: this.form.role.value,
                }).then(() => {
                    this.$emit('created');
                    this.form.team = null;
                    this.form.role = null;
                    this.$validator.reset();
                });
            });
        },
    },
};
</script>

<style scoped>
    .add-button {
        font-size: 1.1rem;
    }
</style>
